export default __webpack_public_path__ + "static/affiliate-program-Software-1@2x-a176856fc22abbe6cfa709f96f29dec9.webp";